var map = {
	"./ID.webp": 779,
	"./INDO.webp": 780,
	"./MY.webp": 781,
	"./TH.webp": 782,
	"./VN.webp": 783,
	"./malaysia.webp": 784
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 393;
module.exports = webpackAsyncContext;